"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.for-each");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  desktopMeganav: '[js-mega-nav="desktop-nav"]'
};
/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */

var _default = function _default() {
  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    desktopMeganav: document.querySelectorAll(selectors.desktopMeganav)
  };
  /**
   * Initialise component.
   */

  function init() {
    setTriggerEvents();
  }
  /**
   * Set trigger listeners.
   */


  function setTriggerEvents() {
    /**
     * Desktop meganav hover
     */
    _toConsumableArray(nodeSelectors.desktopMeganav).forEach(function (item) {
      (0, _utils.on)('mouseover', item, function () {
        openMeganavDesktop(item);
        Frame.EventBus.emit('Toggle:meganav:open');
      });
      (0, _utils.on)('mouseout', item, function () {
        closeMeganavDesktop(item);
        Frame.EventBus.emit('Toggle:meganav:close');
      });
    });
  }

  function openMeganavDesktop(item) {
    item.classList.add(_cssClasses["default"].active);
  }

  function closeMeganavDesktop(item) {
    item.classList.remove(_cssClasses["default"].active);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;